import classNames from "classnames";
import React, { PureComponent } from "react";

import { IStyleSize } from "../Style";

export interface IProgressProps extends Partial<IStyleSize> {
  /**
   * Extend component classes
   * @default undefined
   */
  className?: string;

  /**
   * Number value from 0 to 100
   * @default undefined
   */
  match?: number; // 0..100

  /**
   * Label under stripe
   * @default undefined
   */
  label?: string;
}

/** Component do display progress bar */
export class Progress extends PureComponent<IProgressProps> {
  static defaultProps: Partial<IProgressProps> = {
    size: "md",
  };

  render() {
    const { className, match = 0, label, size } = this.props;
    const classes = classNames(
      "el-progress",
      {
        [`el-progress--size-${size}`]: !!size,
      },
      className,
    );

    return (
      <div className={classes}>
        <div className="el-progress__bar">
          <div style={{ width: match + "%" }} />
        </div>
        {label && <div className="el-progress__label">{label}</div>}
      </div>
    );
  }
}

export default Progress;
